import request from '../../request'
import { UseQueryResult, useQuery } from 'react-query'
import { useBuildQueryParams } from '../../../lib/hooks/useBuildQueryParams'
import { Pagination } from '../../../lib/types/Pagination'
import { useBuildSortingParams } from '../../../lib/hooks/useBuildSortingParams'

type ResultType = {
  recurring: boolean
  recurring_interval: {
    type: string
    day?: number
  }
  createdAt: Date
  updatedAt: Date
  download_url: string
  next_run_at: Date
  name: string
}

export const useGetAgencyExports = ({
  pageIndex,
  pageSize,
  filters,
  sorting,
}: {
  pageIndex?: number
  pageSize?: number
  filters?: Record<string, unknown>
  sorting?: Array<Record<string, unknown>>
}): UseQueryResult<DataWithPagination<ResultType>, Error> => {
  const queryParams = useBuildQueryParams(filters)
  const sortingParams = useBuildSortingParams(sorting)

  return useQuery<DataWithPagination<ResultType>, Error>(
    ['agencies', 'exports', { pageIndex, pageSize, queryParams, sortingParams }],
    ({ signal }) =>
      request({
        url: `/agencies/${queryParams?.agency_id}/reports/exports`,
        method: 'GET',
        params: {
          pageIndex,
          pageSize,
          ...queryParams,
          sorting: sortingParams,
        },
        signal,
      }),
    {
      enabled: !!queryParams?.agency_id,
    },
  )
}
